/**
 * Query keys del dominio Equipo (usuarios + roles + catálogo de permisos).
 *
 * Keys consistentes y serializables (`docs/frontend_conventions.md`, Datos). A
 * diferencia de talonarios/órdenes, la gestión de usuarios/roles es **global** (no
 * acotada por sede; el backend no exige `X-Sede-Id`), así que las keys NO incluyen
 * la sede activa: los datos son los mismos en cualquier sede.
 */

/** Raíz de todas las queries de usuarios (para invalidación amplia). */
export const USERS_ROOT_KEY = ["users"] as const;

/** Raíz de todas las queries de roles (para invalidación amplia). */
export const ROLES_ROOT_KEY = ["roles"] as const;

/** Key de la lista de usuarios agrupada por sede. */
export const usersGroupedQueryKey = () => ["users", "grouped"] as const;

/** Key del detalle de un usuario. */
export const userDetailQueryKey = (username: string) =>
  ["users", "detail", username] as const;

/** Key de la lista de roles (sistema + personalizados). */
export const rolesListQueryKey = () => ["roles", "list"] as const;

/** Key del detalle de un rol. */
export const roleDetailQueryKey = (roleId: string) =>
  ["roles", "detail", roleId] as const;

/** Key del catálogo de permisos (estable: no cambia con la sesión). */
export const permissionsQueryKey = () => ["permissions"] as const;
